import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Logo from './Logo';
import {
  Container,
  Box,
  Link,
  Stack,
  Heading,
  Flex,
  Menu,
  MenuItem,
  MenuList,
  MenuButton,
  IconButton,
  useColorModeValue,
  Button,
} from '@chakra-ui/react';
import { HamburgerIcon } from '@chakra-ui/icons';
import ThemeToggleButton from './ThemeToggleButton';
import { AiFillFileText } from 'react-icons/ai';
import { useAuth } from '../context/AuthContext';

const LinkItem = ({ href, path, children, _target, ...props }) => {
  const active = path === href;
  const inactiveColor = useColorModeValue('gray.200', 'whiteAlpha.900');
  return (
    <Link
      as={RouterLink}
      to={href}
      p={2}
      bg={active ? 'glassTeal' : undefined}
      color={active ? '#202023' : inactiveColor}
      target={_target}
      {...props}
    >
      {children}
    </Link>
  );
};

const Navbar = (props) => {
  const location = useLocation();
  const path = location.pathname;
  const { isAuthenticated, logout } = useAuth();

  return (
    <Box
      position="fixed"
      as="nav"
      w="100%"
      bg={useColorModeValue('#ffffff40', '#20202380')}
      style={{ backdropFilter: 'blur(10px)' }}
      zIndex={1}
      {...props}
    >
      <Container
        display="flex"
        p={2}
        maxW="container.md"
        wrap="wrap"
        align="center"
        justifyContent="space-between"
      >
        <Flex align="center" mr={5}>
          <Heading as="h1" size="lg" letterSpacing="tighter">
            <Logo />
          </Heading>
        </Flex>
        <Stack
          direction={{ base: 'column', md: 'row' }}
          display={{ base: 'none', md: 'flex' }}
          width={{ base: 'full', md: 'auto' }}
          alignItems="center"
          flexGrow={1}
          mt={{ base: 4, md: 0 }}
        >
          <Link
            href="https://github.com/abhudaym/playlist_genie "
            target="_blank"
            display="inline-flex"
            alignItems="center"
            style={{ gap: 4 }}
            pl={2}
            color={useColorModeValue('gray.200', 'whiteAlpha.900')}
          >
            <AiFillFileText />
            Source
          </Link>
        </Stack>
        <Box flex={1} align="right">
          <ThemeToggleButton />
          {isAuthenticated && (
            <Button
              ml={2}
              colorScheme="red"
              size="sm"
              onClick={logout}
              display={{ base: 'none', md: 'inline-flex' }}
            >
              Logout
            </Button>
          )}
          <Box ml={2} display={{ base: 'inline-block', md: 'none' }}>
            <Menu>
              <MenuButton
                as={IconButton}
                icon={<HamburgerIcon />}
                variant="outline"
                aria-label="Options"
              />
              <MenuList>
                <MenuItem
                  as={Link}
                  href="https://github.com/abhudaym/playlist_genie"
                  target="_blank"
                >
                  View Source
                </MenuItem>
                {isAuthenticated && (
                  <MenuItem onClick={logout}>
                    Logout
                  </MenuItem>
                )}
              </MenuList>
            </Menu>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Navbar; 